var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';
import isNil from 'lodash/isNil';
import messages from 'translations/shared';
import { FormGroup, FormSubHeading, FormGroupHeader, FormGroupContent, FormHelperText, } from '@petsly/shared-client';
import SingleSelect from 'components/SingleSelect';
var View = function (_a) {
    var clients = _a.clients, value = _a.value, error = _a.error, touched = _a.touched, onChange = _a.onChange, onBlur = _a.onBlur;
    var formatMessage = useIntl().formatMessage;
    var options = useMemo(function () {
        return clients.map(function (entry) { return ({
            value: entry.id,
            label: "" + entry.name + (entry.phoneNumber ? " (" + entry.phoneNumber + ")" : ''),
        }); });
    }, [clients]);
    var valueFromId = function (opts, id) { return opts.find(function (o) { return o.value === id; }); };
    return (_jsxs(FormGroup, __assign({ border: false }, { children: [_jsx(FormGroupHeader, { children: _jsx(FormSubHeading, { children: formatMessage(messages.client) }, void 0) }, void 0), _jsx(FormGroupContent, { children: _jsxs("div", __assign({ style: { marginBottom: 16 } }, { children: [_jsx(SingleSelect, { options: options, onChange: function (selected) {
                                if (!selected)
                                    return;
                                onChange(selected.value);
                            }, onBlur: function () {
                                onBlur();
                            }, value: valueFromId(options, value) }, void 0), touched && !isNil(error) && (_jsx(FormHelperText, __assign({ error: true }, { children: error }), void 0))] }), void 0) }, void 0)] }), void 0));
};
var shouldRerender = function (prevProps, nextProps) {
    return (prevProps.value === nextProps.value &&
        prevProps.touched === nextProps.touched &&
        prevProps.error === nextProps.error &&
        prevProps.clients === nextProps.clients);
};
export default memo(View, shouldRerender);
